module.exports = __webpack_public_path__ + "static/11-00f46750a355fb491143a949072fdb15.jpg";